/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type GetApprovalContractsFilter = typeof GetApprovalContractsFilter[keyof typeof GetApprovalContractsFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApprovalContractsFilter = {
  InProgress: 'InProgress',
  All: 'All',
  ToDo: 'ToDo',
} as const;
